import { Injectable } from '@angular/core';
import { Country } from '../../models/Country'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import serviceConfig from '../service-config';
import { IndustryType } from '../../models/IndustryType'
import { PersonTitle } from '../../models/personTitle'
import { AppState } from '../../core/reducers/index';
import { selectAuthState } from '../../core/auth/_selectors/auth.selectors';
import { Store } from '@ngrx/store';
import * as jwt_decode from 'jwt-decode';
import { Jwk } from '../../views/session/login/interfaces/Jwk';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  uri = serviceConfig.altBaseUrl;
  uriLogisticW = serviceConfig.logisticWarehouseBaseUrl;
  fileHeaders: HttpHeaders
  headers: HttpHeaders;
  userId: '';

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(selectAuthState).subscribe((result) => {
      console.log("Result: ", result)
      this.fileHeaders = new HttpHeaders()
      .append('Authorization', "Bearer " + result.authToken)
      .append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept, Referer, User-Agent')
      
      var decoded = jwt_decode(result.authToken);
      this.userId = decoded['https://mardom.com/clientId'];
      this.headers = new HttpHeaders()
        .append('Authorization', "Bearer " + result.authToken)
        .append('Content-Type', 'application/json')
        .append('accept', '*/*')
        .append('Allow', '*')
        .append('Access-Control-Allow-Origin', '*')
        .append('Access-Control-Allow-Methods', 'POST, GET, PUT, DELETE, OPTIONS')
        .append('Access-Control-Allow-Headers', 'Origin, X-Requested-With, Content-Type, Accept, Referer, User-Agent')
        .append('accept', 'text/plain');
    })
  }

  ///
  /* Login */
  ///
  publicKey(){
    //let url = "https://localhost:5015/crypto/v1/jwk";
    //const url = "https://localhost:7165/crypto/v1/jwk";
    //let url = "https://mdapima.azure-api.net/api/MDIndentity/crypto/v1/jwk"; PROD
    let url = "https://mdapima.azure-api.net/api/MDIdentityUAT/crypto/v1/jwk" //QA
    return this.http.get<Jwk>(url);
  }

  descryptApi(cipherText: string) : Observable<any> {
    //const url = "https://localhost:5175/User/login";
    //const url = "https://localhost:7069/User/login";
    //const url = 'https://mdapima.azure-api.net/API/MDMGOLogin/api/User/login';
    //const url = "https://mdapima.azure-api.net/api/MDAuthLoginiuat/User/login"; //QA
    const url = "https://mdauthloginiuat-cfbgcce6bjdwbtew.eastus2-01.azurewebsites.net/User/login"; //QA
    const body = {
      ciphertextB64: cipherText
    };

    return this.http.post<any>(url, body, {
      headers: this.headers
    });
  }

  loginApi(email,pass){
    return this.http.get<any>(
      this.uri + serviceConfig.endPoints.loginurl +'?username='+email+'&password='+pass
    )
  }

  ///
  /* RNC */
  ///
  verifyRNC(no): Observable<Country[]> {
    return this.http.get<Country[]>(
      'https://marmgorncapi-g0ephfcvcvftaug4.eastus2-01.azurewebsites.net/GetRNC?rnc=' + no
    )
  }

  ///
  /* Industry */
  ///
  getIndustryTypes(): Observable<IndustryType[]> {
    return this.http.get<IndustryType[]>(
      this.uri + serviceConfig.endPoints.industryType
    )
  }

  ///
  /* Person */
  ///
  getPersonTitle(): Observable<PersonTitle[]> {
    return this.http.get<PersonTitle[]>(
      this.uri + serviceConfig.endPoints.personTitle
    )
  }

  ///
  /* Countries */
  ///
  getCountries(): Observable<Country[]> {
    return this.http.get<Country[]>(
      this.uri + serviceConfig.endPoints.country
    )
  }
  
  ///
  /* Email */
  ///
  sendEmail(email) {
    const url = `${this.uriLogisticW}/Home/SendAuthEmail?emailId=${email}`
    return this.http.get<any[]>(url)
  }

  ///
  /* Email */
  ///
  checkEmailExit(email) {
    const url =  `${this.uriLogisticW}/Home/ValidateEmail?EmailId=${email}`; //FOR UAT ENV
    //const url = `https://localhost:44381/Home/ValidateEmail?EmailId=${email}`; //FOR LOCAL ENV
    return this.http.get<any[]>(`${url}`, { headers: this.headers })
  }

  ///
  ///
  sendSuccessfullRegistrationEmail(payload) {
    const url =`${this.uriLogisticW}/Home/SendSuccessfullRegistrationEmail?email=${payload.email}&username=${payload.name}
    &emailAccount=${payload.emailAccount}&companyName=${payload.companyName}`;
    return this.http.get<any[]>(url)
  }
}
